export default __webpack_public_path__ + "static/sheepish-0be36497ae7159305ac021ca46b1d2b1.svg";